import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Admin routes use el_admin_token, vendor routes use el_vendor_token
  const url = config.url || "";
  let token = null;
  if (url.startsWith("/admin") || url.startsWith("/auth/me") || url.startsWith("/auth/change-password")) {
    token = localStorage.getItem("el_admin_token");
  } else if (url.startsWith("/vendor") || url.startsWith("/auth/vendor/me") || url === "/resources") {
    token = localStorage.getItem("el_vendor_token");
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function getConfig() {
  return (await api.get("/config")).data;
}

// Leads
export async function createLead(payload) {
  return (await api.post("/leads", payload)).data;
}
export async function accessLead(email, code) {
  return (await api.post("/leads/access", { email, code })).data;
}
export async function getLeadByToken(token) {
  return (await api.get(`/leads/by-token/${token}`)).data;
}

// Auth: admin
export async function adminLogin(email, password) {
  return (await api.post("/auth/login", { email, password })).data;
}
export async function adminLogin2fa(challenge_token, code) {
  return (await api.post("/auth/login/2fa", { challenge_token, code })).data;
}
export async function adminMe() {
  return (await api.get("/auth/me")).data;
}
export async function adminChangePassword(current_password, new_password) {
  return (
    await api.post("/auth/change-password", { current_password, new_password })
  ).data;
}
export async function admin2faStatus() { return (await api.get("/auth/2fa/status")).data; }
export async function admin2faSetup() { return (await api.post("/auth/2fa/setup")).data; }
export async function admin2faEnable(code) {
  return (await api.post("/auth/2fa/enable", { code })).data;
}
export async function admin2faDisable(code) {
  return (await api.post("/auth/2fa/disable", { code })).data;
}
export async function adminForgot(email) {
  return (await api.post("/auth/forgot", { email })).data;
}
export async function adminReset(token, new_password) {
  return (await api.post("/auth/reset", { token, new_password })).data;
}

// Auth: vendor
export async function vendorRegister(payload) {
  return (await api.post("/auth/vendor/register", payload)).data;
}
export async function vendorLogin(email, password) {
  return (await api.post("/auth/vendor/login", { email, password })).data;
}
export async function vendorGoogleAuth(session_id) {
  return (await api.post("/auth/vendor/google", { session_id })).data;
}
export async function vendorMe() {
  return (await api.get("/auth/vendor/me")).data;
}
export async function vendorUpdateMe(patch) {
  return (await api.patch("/auth/vendor/me", patch)).data;
}
export async function vendorCheck(code) {
  return (await api.get(`/vendors/check/${code}`)).data;
}

// Vendor dashboard
export async function vendorLeads() {
  return (await api.get("/vendor/leads")).data;
}
export async function vendorCommissions() {
  return (await api.get("/vendor/commissions")).data;
}
export async function vendorResources() {
  return (await api.get("/resources")).data;
}

// Admin
export async function adminListLeads() {
  return (await api.get("/admin/leads")).data;
}
export async function adminUpdateStatus(id, status) {
  return (await api.patch(`/admin/leads/${id}/status`, { status })).data;
}
export async function adminUpdateLead(id, patch) {
  return (await api.patch(`/admin/leads/${id}`, patch)).data;
}
export async function adminDeleteLead(id) {
  return (await api.delete(`/admin/leads/${id}`)).data;
}
export async function adminStats() {
  return (await api.get("/admin/stats")).data;
}
export async function adminListVendors() {
  return (await api.get("/admin/vendors")).data;
}
export async function adminListResources() {
  return (await api.get("/admin/resources")).data;
}
export async function adminCreateResource(payload) {
  return (await api.post("/admin/resources", payload)).data;
}
export async function adminDeleteResource(id) {
  return (await api.delete(`/admin/resources/${id}`)).data;
}
export async function adminNotifications() {
  return (await api.get("/admin/notifications")).data;
}
export async function adminMarkNotificationsRead() {
  return (await api.post("/admin/notifications/read")).data;
}
export async function adminSendSecondPayment(leadId) {
  return (await api.post(`/admin/leads/${leadId}/send-second-payment`)).data;
}

// Packages
export async function getPackages() {
  return (await api.get("/payments/packages")).data;
}

// Stripe checkout
export async function createCheckoutSession(lead_id, plan_id, origin_url) {
  return (
    await api.post("/payments/checkout/session", { lead_id, plan_id, origin_url })
  ).data;
}
export async function getCheckoutStatus(sessionId) {
  return (await api.get(`/payments/checkout/status/${sessionId}`)).data;
}

// Session helpers
export const session = {
  save(lead) {
    localStorage.setItem("el_session", JSON.stringify(lead));
  },
  load() {
    const raw = localStorage.getItem("el_session");
    if (!raw) return null;
    try { return JSON.parse(raw); } catch { return null; }
  },
  clear() { localStorage.removeItem("el_session"); },
};

export function formatErr(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  return err?.message || "Algo salió mal";
}
